import { render } from "./MyRegistration.vue?vue&type=template&id=69451f82&scoped=true"
import script from "./MyRegistration.vue?vue&type=script&lang=js"
export * from "./MyRegistration.vue?vue&type=script&lang=js"

import "./MyRegistration.vue?vue&type=style&index=0&id=69451f82&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-69451f82"

export default script